import type { Fields } from "@vuex-orm/core";
import type InheritanceTypes from "@vuex-orm/core/dist/src/model/contracts/InheritanceTypes";
import { BrowserAction, Scroll } from "./ActionHierarchy";

export class BrowserPlayback extends BrowserAction {
  // This is the name used as module name of the Vuex Store.
  public static entity = "browserPlayback";

  public static baseEntity = "actions";

  public static types(): InheritanceTypes {
    return {
      Scroll,
      BrowserPlayback,
    };
  }

  public static fields(): Fields {
    return {
      ...super.fields(),
    };
  }

  public get duration(): number {
    return ((this.endsAt || 0) - (this.startsAt || 0)) / 1000;
  }

  public static get humanName(): string {
    return "Cut Footage";
  }
}
